import React from 'react';
import Box from '../Box/Box';

type Props = {
  /** Shows a progress bar at the set percentage. Should be between 0 and 1 */
  progress: number;
};

const ProgressBar = ({ progress }: Props) => {
  return (
    <Box height="4px" alignSelf="stretch" bg="gray-200">
      <Box
        height="4px"
        width={`${progress * 100}%`}
        bg="crunchberry"
        sx={{ transition: 'width 75ms ease-in-out' }}
      />
    </Box>
  );
};

ProgressBar.DisplayName = 'ProgressBar';
export default ProgressBar;
